import React, { memo } from 'react';
import { Media, MontanaMediaRatios } from '../media';
import { GREY } from "@montana/constants/colors";
import { IProductImage } from '@montana/models/generated/cms.interface';
import { getImageUrlFromProductImage } from '@montana/helpers/media-src.helper';
import { transformLDImageBackground, transformLDImageFrame } from '@montana/helpers/london-dynamics.helper';

interface IProductImageProps {
    url?: string;
    productImage?: IProductImage;
    name?: string;
    isCylindoImage?: boolean;
    ariaHidden?: boolean;
    bgColor?: string;
    frame?: number;
    className?: string;
    sizes?: string;
    animate?: boolean;
}

export const ProductImage = memo((props: IProductImageProps) => {
    const {
        ariaHidden,
        bgColor = GREY,
        className,
        frame = 1,
        name,
        url,
        productImage,
        isCylindoImage = !productImage?.useAssetImage,
        sizes,
        animate = true
    } = props;

    let imageUrl = !!url ? url : getImageUrlFromProductImage(productImage);

    if (!productImage?.useAssetImage) {
        const urlWithBackground = imageUrl ? transformLDImageBackground(imageUrl, bgColor) : imageUrl;
        imageUrl = urlWithBackground ? transformLDImageFrame(urlWithBackground, frame) : imageUrl;
    }

    return (
        <div
            className={`product-image${!isCylindoImage ? ' product-image--no-padding' : ''}${className ? ` ${className}` : ''}`}
            style={{ backgroundColor: bgColor }}
        >
            <Media
                image={{ url: imageUrl, altText: name ?? imageUrl }}
                mediaRatio={MontanaMediaRatios.Square}
                aria-hidden={ariaHidden}
                placeholder={false}
                animate={animate}
                animateInsideLink={false}
                sizes={sizes}
            />
        </div>
    );
});
